import { render } from "./MenusOverviewItemReferenceEdit.vue?vue&type=template&id=6b40f832&scoped=true&ts=true"
import script from "./MenusOverviewItemReferenceEdit.vue?vue&type=script&lang=ts"
export * from "./MenusOverviewItemReferenceEdit.vue?vue&type=script&lang=ts"

import "./MenusOverviewItemReferenceEdit.vue?vue&type=style&index=0&id=6b40f832&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b40f832"]])

export default __exports__